module.exports = __webpack_public_path__ + "media/app/assets/imgs/events/comment-8d6101dd478eef80686d952858d2a075.svg";